import { render, staticRenderFns } from "./FitGap.vue?vue&type=template&id=e87afd36&scoped=true"
import script from "./FitGap.vue?vue&type=script&lang=js"
export * from "./FitGap.vue?vue&type=script&lang=js"
import style0 from "./FitGap.vue?vue&type=style&index=0&id=e87afd36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87afd36",
  null
  
)

export default component.exports